module.exports = __webpack_public_path__ + "img/plan-finish.c775d404.png";